import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import $ from 'jquery';

@Component({
  selector: 'app-new-dahsboard-sidebar',
  templateUrl: './new-dahsboard-sidebar.component.html',
  styleUrls: ['./new-dahsboard-sidebar.component.scss']
})
export class NewDahsboardSidebarComponent implements OnInit {
  all_urls: any;
  active_module: any;
  userType: any;
  ending: any = { end: -2, title: '' };  
  adminId: any;
;

  constructor(
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService
  ) { }

  ngOnInit(): void {
    this.get_url_and_sms_content_sub();
    const { id } = this.local.getUser();
    this.adminId = id;
    const { userType } = this.local.getUser();
    this.userType = userType;
    this.vip_token_transactions();


  }


  vip_token_transactions() {
    this.auth.vip_token_transactions().subscribe((response: any) => { 
      this.ending = response.body.ending;
      if (this.ending.end == -1) {
//        document.getElementById("link").href = "#";
        $("#feedbackurl").attr("href", "");
      }
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }
  get_url_and_sms_content_sub() {
    this.auth.get_url_and_sms_content_sub().subscribe((response: any) => {
      this.all_urls = response.body;
    });
  }

  open_review_listing(id) {
    this.router.navigate([`admin/review-list/${id}`]);
  }

  open_feedback_url(id) {
    this.router.navigate([`admin/feedback-url/${id}`]);
  }

  active_sidebar(module) {
    this.active_module = module;
    console.log(this.active_module);
  }

}
